import React, { useState } from 'react';
import { Container, Row, Form } from 'react-bootstrap';
import {  IconButton, InputAdornment } from "@mui/material";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Controller, useForm } from 'react-hook-form';
import { useAppDispatch } from 'store/store';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import TextField from 'components/Atoms/TextField';
import { Auth } from 'aws-amplify';
import { triggerUxCritialErrors } from 'actions/error';
import { useHistory, useLocation } from 'react-router-dom';
import { passwordRegex } from 'helpers/constants';

const ForgotPasswordVerifySchema = yup.object().shape({
  verificationCode: yup.string().required("Verification Code is required."),
  password: yup.string()
    .matches(passwordRegex, "Your password does not follow the standards")
    .min(8, "Password should be minimum 8 characters.")
    .required("New Password is required.")
})

function ForgotPasswordVerify(props) {
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();

  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const { handleSubmit, formState: { errors }, control } = useForm({ resolver: yupResolver(ForgotPasswordVerifySchema) });

  const handleShowOrHide = () => {
    setShowPassword(!showPassword);
  }

  const onSubmit = (data) => {
    setIsLoading(true);

    const { username } = location.state;
    const { verificationCode, password } = data;

    Auth.forgotPasswordSubmit(username, verificationCode, password)
      .then((data) => {

        // redirect to next page
        history.replace('/login');

        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        triggerUxCritialErrors(err, dispatch);
      });
  }

  return (
    <Container fluid className="login_container_forget">
      <Row className="login_box">
        <span>Reset Your Password?</span>
        <div>
          <Form className="login_form forgot-password-verify" onSubmit={handleSubmit(onSubmit)}>
            <div className="returning_customer_container">
              <div className="input_fields">
                <Controller name="verificationCode" control={control} render={({ field }) => <TextField
                  {...field}
                  error={Boolean(errors.verificationCode)}
                  fullWidth
                  placeholder="Enter Verification Code"
                  label="Verification Code"
                  helperText={errors.verificationCode?.message}
                />} />

                <list>Password should contain -
                  <ul>
                    <li>Minimum password length - 8.</li>
                    <li>Atleast 1 uppercase.</li>
                    <li>Atleast 1 lowercase.</li>
                    <li>Atleast 1 number.</li>
                    <li>A special character.</li>
                  </ul>
                </list>
                <Controller name="password" control={control} render={({ field }) => <TextField
                  {...field}
                  error={Boolean(errors.password)}
                  helperText={errors.password?.message}
                  fullWidth
                  placeholder="Enter New Password"
                  label="New Password"
                  type={showPassword ? "text" : "password"}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleShowOrHide}
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />} />

              </div>
              <LoadingButton
                type="submit"
                sx={{ py: 1.5 }}
                loading={isLoading}
                loadingPosition="start"
                variant="contained"
                fullWidth
                size="large"
              >
                {`${isLoading ? "Loading..." : "Change Password"}`}
              </LoadingButton>

            </div>
          </Form>
        </div>
      </Row>
    </Container>
  );
}
export default ForgotPasswordVerify;
